module.exports = __webpack_public_path__ + "img/ml.284dad1c.svg";